<template>
  <div :class="wrapperClassObject">
    <el-button
      v-if="detail.data.fallStatus === 'RED'"
      type="primary"
      size="mini"
      plain
      class="bell-button "
      :loading="saveSilenceLoading"
      @click="saveSilenceStatus()"
      :disabled="saveSilenceLoading"
    >
      <img class="mr-5" src="../../assets/image/icon/bell-off.svg" />
      <span>{{ $t('text.silence') }}</span>
    </el-button>
    <img
      v-if="detail.data.fallStatus === 'SILENT'"
      src="../../assets/image/icon/bell-off.svg"
    />
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'

export default {
  data() {
    return {
      saveSilenceLoading: false
    }
  },
  props: {
    detail: {
      required: true,
      type: Object
    }
  },
  computed: {
    wrapperClassObject: function() {
      if (this.$store.state.locale.currentLocale !== 'en')
        return 'newline-bell-wrapper bell-wrapper'
      else return 'bell-wrapper'
    }
  },
  methods: {
    saveSilenceStatus() {
      if (this.saveSilenceLoading || !this.$store.state.patient.selectedPatient)
        return false
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.silence_confirm_box_content'
        )}</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.silence_confirm_box_title'),
        {
          confirmButtonText: this.$t('text.yes'),
          cancelButtonText: this.$t('text.no'),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleSilence()
        })
        .catch(() => {})
    },
    handleSilence() {
      this.saveSilenceLoading = true
      ApiService.silentFallByPatientId({
        patientId: this.$store.state.patient.selectedPatient.patientId,
        podMac: this.detail.data.podMac
      })
        .then(response => {
          if (response.data.success) {
            this.saveSilenceLoading = false
            this.$parent.getDetail()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.saveSilenceLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.bell-wrapper {
  position: absolute;
  right: 10px;
}
.newline-bell-wrapper {
  top: 40px;
}
.bell-button {
  padding: 5px 7px;
  background: white;
  border-color: #02a7f0;
  &:hover,
  &:focus {
    background: white;
    color: #02a7f0;
  }
}
</style>
